module.exports = __webpack_public_path__ + "static/media/bag.1d0b6b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/bag.png
// module id = 2552
// module chunks = 0